import { t } from '@lingui/macro';

export const loaderLabel = (): string => t`Loading`;
